import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NestApiProvider } from '../nest-api';
import { responseArray, responseObj } from '../nest-model/nest-model';

/*
  Generated class for the AccessManagementProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class OvertimeCancelRequestApiProvider {

  module: string = 'overtime';
  model: string = 'overtimeCancelRequest';

  constructor(
    public http: HttpClient,
    public nestApi: NestApiProvider
  ) {
    console.log('Hello AccessManagementProvider Provider');
  }

  getRequestDetail(requestNo: string) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "getRequestDetail";
    const params: any = { requestNo: requestNo };
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseArray<any>>(method, url, params, urlParams, body, contentType);
  }

  checkCancelAvailability(requestNo: string) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "checkCancelAvailability";
    const params: any = { requestNo: requestNo };
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  deleteDraft(requestNo: string) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "deleteDraft";
    const params: any = { requestNo: requestNo };
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  cancel(requestNo: string) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "cancel";
    const params: any = { requestNo: requestNo };
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  approve(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "approve";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  add(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "add";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  saveDraft(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "saveDraft";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/overtime/overtime-cancel-request-api.ts